import http from "./http";

/**
 * Service for the /productos/subcategorias API.
 * All calls go through the central `http` instance — never raw axios.
 */

const BASE = "productos/subcategorias";

// GET /productos/subcategorias devuelve un array JSON directo (solo activas),
// cada item con su categoría bajo la key `category`.
const listar = () => http.get(BASE);

const obtener = (id) => http.get(`${BASE}/${id}`);

const crear = (payload) => http.post(BASE, payload);

const actualizar = (payload) => http.put(BASE, payload);

const eliminar = (id) => http.delete(`${BASE}/${id}`);

export default {
  listar,
  obtener,
  crear,
  actualizar,
  eliminar,
};
